import axios from 'axios';
import * as actionTypes from './constants';

export function getPayment(paymentId) {
  return async function(dispatch) {
    dispatch({ type: actionTypes.GET_PAYMENT_REQUEST });

    try {
      const response = await axios.get(`/payment/${paymentId}`);
      return dispatch({
        type: actionTypes.GET_PAYMENT_SUCCESS,
        payment: response.data
      });
    } catch (e) {
      return dispatch({ type: actionTypes.GET_PAYMENT_REJECT });
    }
  };
}

export function registerPayment(payment) {
  return async function(dispatch) {
    const response = await axios.post('/payment/register', payment);

    dispatch({
      type: actionTypes.REGISTER_PAYMENT_SUCCESS,
      wallet: response.data
    });
  };
}

export const getPaymentHistory = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.GET_PAYMENT_HISTORY_REQUEST
    });
    return axios
      .get('/payment/history')
      .then(response =>
        dispatch({
          type: actionTypes.GET_PAYMENT_HISTORY_SUCCESS,
          history: response.data
        })
      )
      .catch(err =>
        dispatch({
          type: actionTypes.GET_PAYMENT_HISTORY_REJECT
        })
      );
  };
};

export const getNextPayment = () => {
  return dispatch => {
    dispatch({
      type: actionTypes.GET_NEXT_PAYMENT_REQUEST
    });
    return axios
      .get('/payment/next')
      .then(response =>
        dispatch({
          type: actionTypes.GET_NEXT_PAYMENT_SUCCESS,
          payment: response.data
        })
      )
      .catch(err =>
        dispatch({
          type: actionTypes.GET_NEXT_PAYMENT_REJECT
        })
      );
  };
};

export const getPaymentDetails = paymentId => {
  return dispatch => {
    dispatch({
      type: actionTypes.GET_PAYMENT_DETAILS_REQUEST
    });

    return axios
      .get(`/payment/${paymentId}`)
      .then(response =>
        dispatch({
          type: actionTypes.GET_PAYMENT_DETAILS_SUCCESS,
          details: response.data
        })
      )
      .catch(err =>
        dispatch({
          type: actionTypes.GET_PAYMENT_DETAILS_REJECT
        })
      );
  };
};



// WEBPACK FOOTER //
// ./src/payment/actions.js